import { render, staticRenderFns } from "./DocumentInfo.vue?vue&type=template&id=6c22ed72&scoped=true"
import script from "./DocumentInfo.vue?vue&type=script&lang=js"
export * from "./DocumentInfo.vue?vue&type=script&lang=js"
import style0 from "./DocumentInfo.vue?vue&type=style&index=0&id=6c22ed72&prod&lang=scss&scoped=true"
import style1 from "./DocumentInfo.vue?vue&type=style&index=1&id=6c22ed72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c22ed72",
  null
  
)

export default component.exports